import { useEffect, useState } from "react";
import { GetAllDate, UpdatePostingTime } from "../services/DateConfigService";
import { useDispatch } from "react-redux";
import { setErrorMessage, setSuccessMessage } from "../slices/messageSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTimes } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import { formatToHHmmss } from "../utils/dateUtils";

const DateConfig = () => {
  const [weekId, setweekId] = useState(null);
  const [dateConfigs, setDateConfigs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [editTimeBegin, setEditTimeBegin] = useState("");
  const [editTimeEnd, setEditTimeEnd] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDatesOfWeek();
  }, []);

  const fetchDatesOfWeek = async () => {
    if (weekId) {
      setLoading(true);
      try {
        const response = await GetAllDate(weekId);
        if (response.status_code == 200) {
          setDateConfigs(response.data);
        } else {
          dispatch(setErrorMessage(response.message));
        }
      } catch (error) {
        dispatch(setErrorMessage("Có lỗi xảy ra khi lấy dữ liệu"));
      } finally {
        setLoading(false);
      }
    }
  };

  const searchWeek = (e) => {
    e.preventDefault();
    fetchDatesOfWeek();
  };

  const handleEditClick = (dateConfig) => {
    setSelectedDate(dateConfig);
    setEditTimeBegin(dateConfig.timeBegin);
    setEditTimeEnd(dateConfig.timeEnd);
    setShowEditModal(true);
  };

  const handleSaveEdit = async () => {
    const timeBeginFormatted = formatToHHmmss(editTimeBegin);
    const timeEndFormatted = formatToHHmmss(editTimeEnd);
    const response = await UpdatePostingTime(
      selectedDate.id,
      selectedDate.date,
      timeBeginFormatted,
      timeEndFormatted,
      weekId
    );
    if (response.status_code == 200) {
      dispatch(setSuccessMessage("Cập nhật thời gian đăng bài thành công!"));
      fetchDatesOfWeek();
    } else {
      dispatch(setErrorMessage(response.message));
    }
    setShowEditModal(false);
    setSelectedDate(null);
    setEditTimeBegin("");
    setEditTimeEnd("");
  };

  const handleCancelEdit = () => {
    setShowEditModal(false);
    setSelectedDate(null);
    setEditTimeBegin("");
    setEditTimeEnd("");
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Hoạt động";
      case 0:
        return "Không hoạt động";
      default:
        return "Không xác định";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 1:
        return "text-green-600 bg-green-100";
      case 0:
        return "text-red-600 bg-red-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  return (
    <div className="flex justify-center min-h-screen bg-gray-100 dark:bg-gray-900 p-6">
      <div className="max-w-[1200px] w-full flex flex-col bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">
          Quản lý Thời Gian Đăng Bài
        </h2>

        <form onSubmit={searchWeek} className="mb-6 py-4">
          <div className="flex gap-4 items-center">
            <input
              type="text"
              name="search-id"
              id="search-id"
              placeholder="Nhập ID Tuần để tìm kiếm"
              value={weekId || ""}
              onChange={(e) => setweekId(e.target.value)}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            />
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {loading ? "Đang tải..." : "Tìm kiếm"}
            </button>
          </div>
        </form>

        {dateConfigs && dateConfigs.data && dateConfigs.data.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg">
              <thead className="bg-gray-50 dark:bg-gray-700 text-center">
                <tr>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    ID
                  </th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Ngày
                  </th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Thời gian bắt đầu
                  </th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Thời gian kết thúc
                  </th>

                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Thao tác
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                {dateConfigs.data.map((dateConfig) => (
                  <tr
                    key={dateConfig.id}
                    className="hover:bg-gray-50 dark:hover:bg-gray-700"
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                      {dateConfig.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                      {dayjs(dateConfig.date).format("DD/MM/YYYY")}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                      {dateConfig.timeBegin}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                      {dateConfig.timeEnd}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <button
                        onClick={() => handleEditClick(dateConfig)}
                        className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300"
                      >
                        <FontAwesomeIcon icon={faEdit} className="mr-1" />
                        Chỉnh sửa
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-8">
            <h2 className="text-gray-500 dark:text-gray-400 italic">
              {weekId
                ? "Không có dữ liệu cho tuần này"
                : "Vui lòng nhập ID tuần để tìm kiếm"}
            </h2>
          </div>
        )}

        {/* Edit Modal */}
        {showEditModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Chỉnh sửa thời gian
                </h3>
                <button
                  onClick={handleCancelEdit}
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Ngày:{" "}
                    {selectedDate &&
                      dayjs(selectedDate.date).format("DD/MM/YYYY")}
                  </label>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Thời gian bắt đầu:
                  </label>
                  <input
                    type="time"
                    value={editTimeBegin}
                    onChange={(e) => setEditTimeBegin(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Thời gian kết thúc:
                  </label>
                  <input
                    type="time"
                    value={editTimeEnd}
                    onChange={(e) => setEditTimeEnd(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  />
                </div>
              </div>

              <div className="flex justify-end space-x-3 mt-6">
                <button
                  onClick={handleCancelEdit}
                  className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300 dark:bg-gray-600 dark:text-gray-300 dark:hover:bg-gray-500"
                >
                  Hủy
                </button>
                <button
                  onClick={handleSaveEdit}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Lưu
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DateConfig;
